import { Component, ElementRef, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { LoginService } from 'src/app/shared/services/login.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-jaivik-application',
  imports: [],
  templateUrl: './jaivik-application.component.html',
  styleUrl: './jaivik-application.component.scss',
})
export class JaivikApplicationComponent {
   // iframe: ElementRef<HTMLIFrameElement>;
//   @ViewChild('jaivikIframe')
// iframe!: ElementRef<HTMLIFrameElement>;
  iframeUrl: SafeResourceUrl;
  constructor(private sanitize: DomSanitizer, private localStorageSettings: LocalStorageSettingsService, private loginService: LoginService,private router: Router) {
    // this.iframeUrl =this.sanitize.bypassSecurityTrustResourceUrl('http://3.215.18.50:8000/') as string;
    this.iframeUrl = this.sanitize.bypassSecurityTrustResourceUrl(
  environment.jaivikUrl
);
  }

  ngOnInit() {
    window.addEventListener('message', (event:MessageEvent) => {
      console.log('Received message from Jaivik:', event.data);
      if(event.data?.action === 'Logout' && event.origin === new URL(environment.jaivikUrl).origin) {
        this.logout();
      }
        if(event.data?.action === 'NavigateBack' && event.origin === new URL(environment.jaivikUrl).origin) {
          this.navigateBack();
        }
    });
  }

   onIframeLoad(iframe: HTMLIFrameElement) {
  //     if (!this.iframe?.nativeElement?.contentWindow) {
  //   console.error('Iframe not available');
  //   return;
  // }
  console.log('Iframe loaded');
  console.log(iframe);
  console.log(iframe.contentWindow);

    const payload = {
      token: localStorage.getItem('AuthToken'),
      userId: localStorage.getItem('UserId'),
      workspaceId: localStorage.getItem('WorkspaceId'),
      username: localStorage.getItem('AuthUsername'),
      dnsName: localStorage.getItem('dnsName')
    };

    console.log('Sending to Jaivik:', payload);

    iframe.contentWindow?.postMessage(
      payload,
      environment.jaivikUrl

    );
    // "NavigateBack"
  }

   logout() {
      const msalUser:boolean=JSON.parse(this.localStorageSettings.getSettings("msalUser"));
      if(msalUser){
        this.loginService.msalLogoutmethod();
        // this.msalService.logoutRedirect({postLogoutRedirectUri:'http://localhost:4200'})
      }else{
        this.loginService.logoutmethod();
      }
      // calling logout api from login service 
      

    
  }

  navigateBack() {
    this.router.navigateByUrl('/user/Menubar/home');
  }
}
